/**
 * Helper: Fade in elements
 * ------------------------------------------------------------------------------
 * @namespace fadeInElements
 */


/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-fade-in="container"]',
  item: '[js-fade-in="item"]',
};

/**
 * Settings for intersection.
 */
const config = {
  threshold: 0.5,
};

let observer;

/**
 * Export new redirect helper function.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    containers: [...document.querySelectorAll(selectors.container)],
  };

  /**
   * Initialise component.
   */
  function init() {
    registerObserver();
  }


  /**
   * Register intersection observer
   */
  function registerObserver() {
    const delayStep = 150;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const targets = [...entry.target.querySelectorAll(selectors.item)];

        if (entry.boundingClientRect.y < 0) {
          return;
        }

        if (entry.intersectionRatio > 0) {
          targets.forEach((element, index) => {
            const delay = index * delayStep;
            window.setTimeout(() => {
              element.classList.remove('is-loaded');
            }, delay);
          });

          observer.unobserve(entry.target);
        } else {
          targets.forEach((element) => {
            element.classList.add('is-loaded');
          });
        }
      });
    }, config);

    nodeSelectors.containers.forEach((container) => {
      observer.observe(container);
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
